import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Ensures HTTPS for production API URLs and formats the URL correctly
 * @param baseUrl - The API URL to check
 * @returns The formatted URL with HTTPS if in production, original URL otherwise
 */
export function getApiUrl(baseUrl: string): string {
  // Remove trailing slash if present
  if (baseUrl.endsWith('/')) {
    baseUrl = baseUrl.slice(0, -1);
  }
  
  // Make sure we have the correct path format
  if (!baseUrl.endsWith('/api/v2')) {
    // If the URL already contains /api/ but not the full path
    if (baseUrl.includes('/api/')) {
      // Replace with the correct version
      baseUrl = baseUrl.replace(/\/api\/.*$/, '/api/v2');
    } else {
      // Add the api/v2 path
      baseUrl = `${baseUrl}/api/v2`;
    }
  }
  
  if (!baseUrl) {
    console.error('API URL is undefined');
    return '';
  }

  // Only log in development
  if (import.meta.env.DEV) {
    console.log('Processing API URL:', {
      original: baseUrl,
      isProd: import.meta.env.PROD,
      mode: import.meta.env.MODE
    });
  }

  // Force HTTPS in production
  if (import.meta.env.PROD) {
    const httpsUrl = baseUrl.replace(/^http:/, 'https:');
    if (import.meta.env.DEV) {
      console.log('Production URL:', httpsUrl);
    }
    return httpsUrl;
  }

  if (import.meta.env.DEV) {
    console.log('Development URL:', baseUrl);
  }
  return baseUrl;
}

/**
 * Formats a date string to YYYY-MM-DD format
 * @param date - The date to format
 * @returns Formatted date string
 */
export function formatDate(date: Date): string {
  return date.toISOString().split('T')[0];
}
